// extracted by mini-css-extract-plugin
module.exports = {"root":"InboundProxyRulesTableActions_root__eO6Hh","action":"InboundProxyRulesTableActions_action__zzze_","linkAction":"InboundProxyRulesTableActions_linkAction__11Xhf"};